<template>
  <div>

    <b-row class="mt-1 mb-4">
      <b-col>
        <b-button class="pull-right" variant="primary" v-b-modal.create_update>Update aanmaken</b-button>
      </b-col>
    </b-row>

    <table class="table table-hover">
      <thead>
      <tr>
        <th>Naam</th>
        <th>Datum</th>
        <th>Bekijk</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="update in updates">
        <td>{{update.name}}</td>
        <td>{{update.published_at}}</td>
        <td>
          <b-btn size="sm" variant="primary" class="mr-2" @click="openUpdate(update)">Bekijk</b-btn>
          <b-btn size="sm" variant="danger" @click="openDestroyModal(update)">Verwijderen</b-btn>
        </td>
      </tr>
      </tbody>
    </table>

    <b-modal id="create_update" title="Update aanmaken" hide-footer>
      <b-form @submit.prevent="createItem">
        <b-form-group label="Naam">
          <b-form-input type="text" required v-model="update.name"></b-form-input>
        </b-form-group>
        <hr>
        <b-button class="pull-left" variant="danger" @click="closeCreateModal">Annuleer</b-button>
        <b-button type="submit" class="pull-right" variant="success">Maak update aan</b-button>
      </b-form>
    </b-modal>

    <b-modal id="destroy_update" ref="destroy_update" title="Update verwijderen">
      <p class="my-4">
        Weet je zeker dat je het object <strong v-if="deletable">"{{ deletable.name }}"</strong> wilt verwijderen? Deze actie is onomkeerbaar.
      </p>
      <template v-slot:modal-footer>
        <b-button @click="closeDestroyModal">Nee</b-button>
        <b-button variant="danger" @click="destroyItem">Ja, verwijder</b-button>
      </template>
    </b-modal>

  </div>
</template>
<script>
import {addData, deleteItem} from "@/api";

export default {
  name: 'project-updates',
  props: ['updates', 'projectId'],

  data() {
    return {
      update: {
        name: null
      },
      deletable: null,
    }
  },

  methods: {
    async createItem() {
      const request = await addData(`projects/${this.projectId}/updates`, {
        name: this.update.name
      }).then(response => response);

      if (request.status === 201) {
        return this.$router.push({ name: 'projects.updates.view', params: {id: this.projectId, update_id: request.data.data.id}});
      }
    },

    async destroyItem() {
      const request = await deleteItem(`projects/${this.projectId}/updates/${this.deletable.id}`).then(response => response);

      if (request.status === 200) {
        this.updates = this.updates.filter(update => update.id !== this.deletable.id);
        this.deletable = null;
        this.closeDestroyModal();
      }
    },

    closeCreateModal() {
      this.$bvModal.hide('create_update');
      this.update = {
        name: null,
      };
    },

    openDestroyModal(item) {
      this.deletable = item;
      this.$bvModal.show('destroy_update');
    },

    closeDestroyModal() {
      this.$bvModal.hide('destroy_update');
    },

    openUpdate(update) {
      return this.$router.push({ name: 'projects.updates.view', params: {id: this.projectId, update_id: update.id}});
    }
  }
}
</script>
